"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceNumber = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var cashLoanAuth_1 = require("../../model/cashLoanAuth");
var service_1 = require("../../../library/base/service");
var ServiceNumber = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ServiceNumber, _super);
    function ServiceNumber() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '现金贷客服电话接口';
        _this.code = '101116';
        _this.desc = '现金贷客服电话接口';
        _this.requestParams = new cashLoanAuth_1.ServiceNumberRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ServiceNumber;
}(service_1.BaseService));
exports.ServiceNumber = ServiceNumber;
//# sourceMappingURL=serviceNumber.js.map